<template lang="pug">
  .component-policy
    .inner-content(v-if="$is('listing')")
      .row
        .column.shrink
          dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
            RegistrationTokenButtons(:item="item", @itemUpdated="$emit('itemUpdated')")
        .column.shrink
          .label RT{{item.id}}
        .column.text-center
          .label Token
          .field {{item.token}}
        .column.text-center
          .label Type
          .field {{item.destination_type}}
        .column.text-center
          .label Destination
          .field {{item.destination_name}}
        .column.text-center
          .label Created
          .field {{item.created_at}}


</template>

<script>

import ModalReveal from "../structure/foundation/ModalReveal";
import Dropdown from "../structure/foundation/Dropdown";
import RegistrationTokenButtons from "../structure/ui/actions/RegistrationTokenButtons";

export default {
  name: 'RegistrationToken',
  components: {RegistrationTokenButtons, Dropdown, ModalReveal},
  props: ['item', 'type'],
  data: function () {
    return {
      strippedMessage: ''
    }
  },
  methods: {
    getStrippedMessage() {

      if (this.item.message.subject) {
        this.strippedMessage = this.item.message.subject
      } else {
        this.strippedMessage = JSON.stringify(this.item.message).slice(0, 160)
      }
      return this.strippedMessage
    }
  }
}
</script>

<style lang="sass" rel="stylesheet/sass">
.flex0
  flex: 0 0 30%

</style>



// WEBPACK FOOTER //
// RegistrationToken.vue?520f3138